document.addEventListener('DOMContentLoaded', () => {
  // slick default setting
  let defaulsettings = {
      loop: true,
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
          crossFade: true
      },
      navigation: {
          nextEl: ".sw-gal-next",
          prevEl: ".sw-gal-prev",
      },
      autoplay: {
          delay: 11000,
          disableOnInteraction: false
      },
  };

  let allSwipper =[];
  document.querySelectorAll('.swiper-slider').forEach((element,i) => {
      let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
      element.setAttribute(`data-swiper-${i}`,"");
      let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
      allSwipper[i] = swiper;

  });


    let cards = new Swiper(".card-swiper", {
        speed: 700,
        loop:true,
        slidesPerView:1,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable:true
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                centeredSlides: false
            }
        }
    });

     let sliderColumns = new Swiper(".slider-columns-swiper", {
        speed: 700,
        loop:true,
        slidesPerView:1,
        spaceBetween: 20,
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    });
    
    var stepParity = 1;
    var lastReal = null;

    var slider = new Swiper(".slider-slider", {
    speed: 700,
    rewind: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    navigation: {
        nextEl: ".sw-gal-next",
        prevEl: ".sw-gal-prev",
    },
    });

    let locationTap = document.querySelectorAll('.location-block');
    let locationSlide = document.querySelectorAll('.location-slider');

    if(locationSlide){

        const locationSlider = new Swiper('.location-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        locationTap.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.location-point');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(locationTap.length > 1){
                        locationSlider[hBc].slideTo(navCount, 500);
                    } else {
                        locationSlider.slideTo(navCount, 500);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(locationTap.length > 1){
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    let navIn = 0;
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider.realIndex == navC && navIn != 0){
                                h_nav.classList.add('active');
                            }
                            navIn++;
                        });
                    });
                }
            });
        });
    }


    let sliderHistory = new Swiper(".history__slider", {
        speed: 700,
        effect: "fade",
        autoHeight: true,
        fadeEffect: { crossFade: true },
        pagination: {
            el: ".history-pagination",
            clickable:true
        },
    });

    var sliderNew = new Swiper(".new-slider-intern", {
        speed: 700,
        rewind: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoHeight: true,
        navigation: {
            nextEl: ".sw-new-next",
            prevEl: ".sw-new-prev",
        },
        breakpoints: {
            1024: {
                autoHeight: false,
            }
        }
    });

});